/***************************************************************************/
"use client";
/***************************************************************************/

import { VariantProps, cva } from "class-variance-authority";
import * as React from "react";
import { cn } from "../../utils/css";
import { Flex, flexVariants } from "./flex";

const buttonGroupVariants = cva("flex", {
  variants: {
    gap: {
      default: "gap-2",
      none: "gap-0",
      xs: "gap-0.5",
      sm: "gap-1",
      lg: "gap-3",
    },
  },
  defaultVariants: {
    gap: "default",
  },
});

const ButtonGroup: React.FC<
  React.HTMLAttributes<HTMLDivElement> &
    Omit<VariantProps<typeof flexVariants>, "gap"> &
    VariantProps<typeof buttonGroupVariants>
> = ({ className, gap, ...props }) => {
  return (
    <Flex className={cn(buttonGroupVariants({ gap }), className)} {...props} />
  );
};

export { ButtonGroup, buttonGroupVariants };
